export enum RoleType {
    SUPER_ADMIN = 'super_admin',
    OWNER = 'owner',
    ADMIN = 'admin',
    PROJECT_ADMIN = 'project_admin',
    EDITOR = 'editor',
    REVIEWER = 'reviewer',
    VIEWER = 'viewer',
    MEMBER = 'member',
    SUPPORT = 'support'
}
